export * from "./Availability";
export * from "./Bookings";
export * from "./Checkout";
export * from "./Event";
export * from "./Location";
export * from "./Media";
export * from "./Pricing";
export * from "./Product";
export * from "./Profile";
export * from "./Service";

export enum PeriodIntervalUnit {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
}

export enum PublishableStatus {
  DRAFT = "draft",
  RELEASE = "release",
  ARCHIVED = "archived",
}

export enum UserAccountStatus {
  DISABLED = "disabled",
  INVITED = "invited",
  ENABLED = "enabled",
  DECINED = "decined",
}

export enum BusinessType {
  COMPANY = "company",
  INDIVIDUAL = "individual",
  NONPROFIT = "nonprofit",
  GOVERNMENT_ENTITY = "government_entity",
}

export enum Gender {
  MALE = "male",
  FEMALE = "female",
  UNISEX = "unisex",
}
